<template>
    <ul class="pagination justify-content-center">
        <li v-if="paginaActual !== 1" class="page-item">
            <a class="page-link" href="#" aria-label="Previous" @click.prevent="obtenerPaginaAnterior">
                <span aria-hidden="true">&laquo;</span>
            </a>
        </li>
        <li class="page-item" :class="{ active: pagina === paginaActual }" v-for="pagina in totalPaginas()" :key="pagina">
            <a class="page-link" href="#" @click.prevent="obtenerPaginaActual(pagina)">{{pagina}}</a>
        </li>
        <li v-if="totalPaginas() !== paginaActual" class="page-item">
            <a class="page-link" href="#" aria-label="Next" @click.prevent="obtenerPaginaSiguiente">
                <span aria-hidden="true">&raquo;</span>
            </a>
        </li>
    </ul>
</template>

<script>


export default{
    emits: ['pagina-actualizada'],
    props: {
        datosPop: {
            type: Array,
            default: () => [],
        },
        paginaActual: {
            type: Number,
            default: 1,
        },
    },
    data(){
        return{
            elementosPorPagina: 20,
        }
    },
    methods: {
         obtenerPaginaActual(noPagina = 0){
            this.$emit('pagina-actualizada', noPagina);
        },
        totalPaginas(){
            return Math.ceil(this.datosPop.length / this.elementosPorPagina);
        },
        obtenerPaginaAnterior(){
            if(this.paginaActual > 1) this.$emit('pagina-actualizada', this.paginaActual - 1);
        },
        obtenerPaginaSiguiente(){
            if(this.paginaActual < this.totalPaginas()) this.$emit('pagina-actualizada', this.paginaActual + 1);
        },
    }  
}


</script>

<style scoped lang="scss">
    .pagination{
        .page-link{
            color: #111;
        }
        .page-item.active{
            .page-link{
                background-color: #0b94cf;
                border-color: #0b94cf;
                color: #fff;
            }
        }
    }
</style>
